@if (isVisible() && animationSettings()) {
    <div
        class="ingame-animation-container"
        [class]="isHiding() ? 'animate__animated animate__fadeOut' : ''"
        [style.top.px]="animationSettings().top"
        [style.left.px]="animationSettings().left">
        <div class="animation-content">
            <div class="message">
                @if (animationSettings().message) {
                    <h1 [class]="isHiding() ? animationSettings().hideAnimation : animationSettings().showAnimation">
                        {{ animationSettings().message }}
                    </h1>
                }
            </div>
        </div>
    </div>
}
